import { render, staticRenderFns } from "./BusinessFormsK1.vue?vue&type=template&id=222fdfbc&"
import script from "./BusinessFormsK1.vue?vue&type=script&lang=ts&"
export * from "./BusinessFormsK1.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessFormsK1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports